/*
 * @Description: Payload parsing utilities with performance optimizations
 * @Usage: Parse request body based on content-type with caching
 * @Author: richen
 * @Date: 2023-12-09 12:02:29
 * @LastEditTime: 2025-01-20 10:00:00
 * @License: BSD (3-Clause)
 * @Copyright (c): <richenlin(at)gmail.com>
 */

import { DefaultLogger as Logger } from "koatty_logger";
import { KoattyContext } from "koatty_core";
import { PayloadOptions } from "../interface";
import { parseText } from "./text";


/**
 * Parse request body as JSON
 * @param {KoattyContext} ctx - Koatty context object
 * @param {PayloadOptions} opts - Payload parsing options
 * @returns {Promise<Record<string, any>>} Parsed JSON object, or empty object if parsing fails
 */
export async function parseJson(ctx: KoattyContext, opts: PayloadOptions) {
  const str = await parseText(ctx, opts);
  if (!str) return {};

  try {
    const parsed = JSON.parse(str);
    // Return flat object; wrap non-object values for consistency
    return (parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed))
      ? parsed
      : { value: parsed };
  } catch (error) {
    Logger.Error(error);

    return {};
  }
}
